<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.875 4.5H4.125C3.08947 4.5 2.25 5.33947 2.25 6.375V17.625C2.25 18.6605 3.08947 19.5 4.125 19.5H19.875C20.9105 19.5 21.75 18.6605 21.75 17.625V6.375C21.75 5.33947 20.9105 4.5 19.875 4.5Z"
      :stroke="fillColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.25 7.5L12 12.75L18.75 7.5"
      :stroke="fillColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "EmailSVG",
  props: {
    fillColor: {
      type: String,
      default: "#26262C",
    },
  },
};
</script>
